'use client';

import type { PaginatedProduct } from '@dealerportal/common';
import { getPDPURL } from '@dealerportal/utilities';
import { useCallback, useEffect, useState } from 'react';
import type { PlatformType } from '../Contexts/CatalogContext';

export const useProductLink = () => {
  const [currentPlatform, setCurrentPlatform] = useState<PlatformType>('DP');
  const [pdpPath, setPdpPath] = useState<string>('');

  useEffect(() => {
    // Check if window.catalogConfig exists and extract platform
    if (typeof window === 'undefined') return;

    if (window.catalogConfig?.currentPlatform) {
      setCurrentPlatform(window.catalogConfig.currentPlatform);
    }

    if (
      window.catalogConfig?.currentPlatform === 'MM' &&
      typeof window.wpProductCategory !== 'undefined'
    ) {
      setPdpPath(`/${window.wpProductCategory.rewrite_slug}`);
    }
  }, []);

  const generateProductLink = useCallback(
    (
      product: Pick<PaginatedProduct, 'slug' | 'sku'>,
      options?: {
        seeInRoom?: boolean;
        hash?: string;
      }
    ): string => {
      const { slug, sku } = product;
      const { seeInRoom = false, hash = '' } = options || {};

      const hashValue = seeInRoom ? 'visID_wrapper' : hash;

      return `${pdpPath}${getPDPURL(currentPlatform, slug, sku, hashValue)}`;
    },
    [currentPlatform, pdpPath] // Recreate function when platform or path changes
  );

  return {
    currentPlatform,
    generateProductLink,
  };
};
